import {
    BarChart3Icon,
    CreditCardIcon,
    HomeIcon,
    KeyRoundIcon,
    LayoutGridIcon,
    QubitIcon,
    SettingsIcon,
    UsersIcon,
    WebhookIcon,
} from '@ionq/ui/icons';

// Same icon set ionq-cloud-ui's sidebar uses, so the console shell reads
// identically to the app it will host via federation.
export const PAGE_ICONS_MAP = {
    HOME: HomeIcon,
    MY_JOBS: WebhookIcon,
    PROJECTS: LayoutGridIcon,
    BACKENDS: QubitIcon,
    API_KEYS: KeyRoundIcon,
    SETTINGS: SettingsIcon,
    // The footer's Account Settings control: the classic gear, same glyph
    // in both apps' chromes.
    ACCOUNT_SETTINGS: SettingsIcon,
    ORG_MEMBERS: UsersIcon,
    USAGE_REPORTING: BarChart3Icon,
    SPEND: CreditCardIcon,
};
